import styled, { css } from 'styled-components';

const EditableCTABannerStyled = styled.section.attrs({
  className: 'cta-editable-banner',
})`
  ${({ inline, hideOnMobile }) => {
    return css`
      .cta-editable-banner {
        display: flex;
        flex-direction: ${inline ? 'row' : 'column'};
        justify-content: center;
        align-items: center;
        font-weight: 700;
        font-size: 18px;
        margin-left: 2rem;
        margin-right: 2rem;
        margin-bottom: 20px;

        ${hideOnMobile
          ? `@media (max-width: 600px) {
          display: none;
        }`
          : ''}
      }

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        max-height: 42px;
        font-size: 18px;
        width: 181px;
        white-space: nowrap;
      }

      p {
        line-height: 1.25;
        ${inline ? 'margin: 0 2rem 0 0;' : 'margin-bottom: 1rem;'}
      }
    `;
  }}
`;

export default EditableCTABannerStyled;
